import React, { useEffect, useState } from 'react';
import { Field, Form, Formik, useFormikContext } from 'formik';
import * as Yup from 'yup';
import { Button, Label } from 'edozvola-frontend-lib/dist/ui';
import { Col, FormGroup, Row } from 'reactstrap';
import { CaseExecutabilityValidityModel } from 'app/edozvola/cases/cases.model';
import { useNavigate, useParams } from 'react-router-dom';
import { fetchCaseExecutabilityValidity, saveCaseExecutabilityValidity } from 'app/edozvola/cases/service/cases.service';
import { APP_DATE_FORMAT, ERRORS, messages } from 'app/config/constants';
import { showToast } from 'app/shared/util/toast.util';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { initCaseFormChange, setFormChanged } from 'app/shared/reducers/case-form-change';
import { FormikDatepicker } from 'edozvola-frontend-lib/dist/ui/components/datepicker/FormikDatepicker';
import {updateCaseExecutabilityValidityMutation} from "app/edozvola/cases/service/cases.queries";
import { getCaseContext } from 'app/shared/util/context-util';

const CaseExecutabilityValidityForm = () => {
  const { id } = useParams<{ id: string }>();
  const [initialData, setInitialData] = useState<CaseExecutabilityValidityModel>({} as CaseExecutabilityValidityModel);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {mutate: saveMutation, isPending: isSaving} = updateCaseExecutabilityValidityMutation(id, (data) => {
    setInitialData(data);
    showToast(toast.success, messages.DATA_SAVED);
  }, error => {
    if (Object.values(ERRORS).includes(error.response?.data?.detail)) {
      showToast(toast.error, error.response?.data?.detail);
    } else {
      showToast(toast.error, ERRORS.GENERIC_ERROR);
    }
  });

  const {sidebarItemPair} = getCaseContext()

  useEffect(() => {
    fetchCodebooks().then(() => {
      fetchCaseExecutabilityValidity(id)
        .then(data => {
          setInitialData(data);
        })
        .catch(error => {
          if (Object.values(ERRORS).includes(error.response?.data?.detail)) {
            showToast(toast.error, error.response?.data?.detail);
          } else {
            showToast(toast.error, ERRORS.GENERIC_ERROR);
          }
          navigate('/cases/');
        });
    });
  }, [id]);

  const fetchCodebooks = async () => {};

  const FormikValueObserver = ({ onChange }) => {
    const { dirty } = useFormikContext();

    useEffect(() => onChange({ dirty }), [dirty, onChange]);

    return null;
  };

  const validation = Yup.object({
    executionDate: Yup.string().required(messages.MANDATORY_FIELD),
  });

  const handleSubmit = (values, { setSubmitting }) => {
    saveMutation(values);
  };

  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={initialData}
        validationSchema={validation}
        validateOnMount={true}
        onSubmit={handleSubmit}
      >
        {({ errors, isValid, dirty, submitForm, setFieldValue }) => (
          <Form>
            <FormikValueObserver
              onChange={dirty => {
                if (dirty.dirty) {
                  dispatch(setFormChanged(true));
                } else {
                  dispatch(initCaseFormChange());
                }
              }}
            />
            <h5 className={'form-header'}>Izvršnost i pravomoćnost završnog akta</h5>
            <Row>
              <Col xs={4}>
                <FormGroup>
                  <Label labelText={'Datum izvršnosti'} />
                  <Field
                    id="executionDate"
                    name="executionDate"
                    render={({ field }) => (
                      <FormikDatepicker
                        error={!sidebarItemPair.readOnly && errors.executionDate as string}
                        field={field}
                        setFieldValue={setFieldValue}
                        dateFormat={APP_DATE_FORMAT}
                        disabled={sidebarItemPair.readOnly}
                      />
                    )}
                  />
                </FormGroup>
              </Col>
              <Col xs={4}>
                <FormGroup>
                  <Label labelText={'Datum pravomoćnosti'} />
                  <Field
                    id="effectivenessDate"
                    name="effectivenessDate"
                    render={({ field }) => (
                      <FormikDatepicker
                        field={field}
                        setFieldValue={setFieldValue}
                        dateFormat={APP_DATE_FORMAT}
                        disabled={sidebarItemPair.readOnly}
                      />
                    )}
                  />
                </FormGroup>
              </Col>
            </Row>

            {!sidebarItemPair.readOnly && (
              <div className="case-save-button">
                <Button
                  color={'info'}
                  label={'Spremi'}
                  isLoading={isSaving}
                  size={'lg'}
                  onClick={submitForm}
                  disabled={!dirty || !isValid}
                />
              </div>
            )}
          </Form>
        )}
      </Formik>
    </>
  );
};

export default CaseExecutabilityValidityForm;
